import { SLOTS } from './slots.js'

// Polls — daily poll rotation per college town. Drag-reorderable. Active is an
// in-table toggle (the canonical way an on/off state renders); pages pass onToggle.
export default {
  key: 'poll',
  deleteLabel: 'Archive',
  label: 'Poll',
  icon: 'polls',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.STATUS, field: 'active', label: 'Active', renderer: 'toggle' },
    // Rank = row order in the shown list (old CMS List*Row printed index + 1)
    { slot: SLOTS.METADATA, field: 'rank', label: 'Rank', renderer: 'points', align: 'right' },
    { slot: SLOTS.METADATA, field: 'schedule', label: 'Schedule', renderer: 'schedule' }
  ],
  empty: { icon: 'polls', message: 'No polls found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT] }
}
